import React from 'react';
import PropTypes from 'prop-types';
import { Cloudinary } from 'cloudinary-core';

import PdfIcon from '../../../common/img/components/PdfIcon';

const MultimediaPdfItem = ({ cloudinaryCloudName, mediaProperties }) => {
  const cloudConfig = new Cloudinary({ cloud_name: cloudinaryCloudName });
  const pdfUrl = cloudConfig.url(mediaProperties.publicId);

  return (
    <div className="multimedia-add-ons__wrapper__pdf">
      <div className="multimedia-add-ons__wrapper__pdf__icon">
        <PdfIcon />
      </div>
      <div className="multimedia-add-ons__wrapper__pdf__text">
        <div className="multimedia-add-ons__wrapper__pdf__text__name">
          {mediaProperties.caption !== '' ? mediaProperties.caption : mediaProperties.fileName.split('.pdf')[0]}
        </div>
        <div className="multimedia-add-ons__wrapper__pdf__text__link">
          <a target="_blank" rel="noreferrer" href={pdfUrl}>Download Report</a>
        </div>
      </div>
    </div>
  );
};
MultimediaPdfItem.propTypes = {
  mediaProperties: PropTypes.shape({
    publicId: PropTypes.string.isRequired,
    multimediaAddOnId: PropTypes.number.isRequired,
    fileName: PropTypes.string.isRequired,
    mediaType: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
  }).isRequired,
  cloudinaryCloudName: PropTypes.string.isRequired,
};

export default MultimediaPdfItem;
